var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1215,
    y: 26,
    width: 34,
    height: 34
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1215 -26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1229.88 28.4792 1234.12 28.4792 1234.12 44.0625 1229.88 44.0625Z",
    fill: "#2269BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.72 33.0479 1237.28 36.5187C1239.65 38.1833 1241.21 40.9458 1241.21 44.0625 1241.21 49.1271 1237.06 53.2708 1232 53.2708 1226.94 53.2708 1222.79 49.1271 1222.79 44.0625 1222.79 40.9458 1224.35 38.1833 1226.72 36.5187L1224.28 33.0479C1220.81 35.4562 1218.54 39.4937 1218.54 44.0625 1218.54 51.5 1224.56 57.5208 1232 57.5208 1239.44 57.5208 1245.46 51.5 1245.46 44.0625 1245.46 39.4937 1243.19 35.4562 1239.72 33.0479Z",
    fill: "#2269BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.6508a23ef151d6292308b81a4f1b0ace.svg";
export { ForwardRef as ReactComponent };